import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import { API_KEY, BASE_URL } from "./config";

Modal.setAppElement('#root');

function ManualHedge({ isOpen, closeModal, symbolData }) {
  const [formData, setFormData] = useState({
    signalRequestId: symbolData.signalRequestId || null,
    symbol: symbolData.symbol || '',
    side: symbolData.side || '',
    forceHedge: 'true',
    hedgePercentage: 100,
    orderType: 'market', // default value
    limitPrice: '', // to be fetched from backend
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [submissionResult, setSubmissionResult] = useState(null);
  const [showDropdown, setShowDropdown] = useState(true);

  const toggleInputType = () => {
    setShowDropdown(!showDropdown);
    if (!showDropdown) {
      // Reset to a default value when switching back to dropdown
      setFormData({ ...formData, closurePercentage: '50' });
    }
  };

  useEffect(() => {
    const fetchMarketPrice = async () => {
      const response = await fetch(`${BASE_URL}/api/bot/get/getMarkPriceBySymbol?symbol=${formData.symbol}`,
                      {
                        headers: {
                          "X-SIGNALFLY-KEY": API_KEY
                        }
                      });
      const data = await response.json();
      setFormData(prevFormData => ({ ...prevFormData, limitPrice: data.markPrice }));
    };

    if (formData.symbol) {
      fetchMarketPrice();
    }
  }, [formData.symbol]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevFormData => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    manualHedgePost(formData);
  };

  const manualHedgePost = (formSubmittedData) => {
    setLoading(true);
    fetch(`${BASE_URL}/api/bot/ui/post/placeManualHedgeOrder`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        "X-SIGNALFLY-KEY": API_KEY
      },
      body: JSON.stringify(formSubmittedData),
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(data => {
      setSubmissionResult(data);
      setLoading(false);
    })
    .catch(error => {
      setError(error.message);
      setLoading(false);
    });
  };

  

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={closeModal}
      contentLabel="Manual Hedge Parameters"
      className="ReactModal__Content"
      overlayClassName="ReactModal__Overlay"
    >
      <button className="modal-close-button" onClick={closeModal}>&times;</button>
      <h2 className="page-title">Manual Hedge Parameters</h2>
      <br/>
      {loading && <div className="loading-message">Loading...</div>}
      {error && <div>Error: {error}</div>}
      {submissionResult && <div>Result: {JSON.stringify(submissionResult)}</div>}

      {!loading && !submissionResult && (
        <form className="modal-form" onSubmit={handleSubmit}>
        <label>
          Signal Request ID:
          <input
            type="text"
            name="signalRequestId"
            value={formData.signalRequestId}
            readOnly
          />
        </label>
        <label>
          Symbol:
          <input
            type="text"
            name="symbol"
            value={formData.symbol}
            readOnly
          />
        </label>
        <label>
          Signal Side: 
          <input
            type="text"
            name="side"
            value={formData.side}
            readOnly
          />
        </label>
        <label>
          Order Type:
          <select
            name="orderType"
            value={formData.orderType}
            onChange={handleInputChange}
          >
            <option value="limit">Limit</option>
            <option value="market">Market</option>
            <option value="normal_plan">Trigger</option>
          </select>
        </label>
        <label>
          Hedge Type:
          <select
            name="forceHedge"
            value={formData.forceHedge}
            onChange={handleInputChange}
          >
            <option value="true">Force Hedge</option>
            <option value="false">Normal</option>
          </select>
        </label>
        <label>
          Price:
          <input
            type="text"
            name="limitPrice"
            value={formData.limitPrice}
            onChange={handleInputChange}
          />
        </label>
        <label>
          Hedge Size:
          {showDropdown ? (
            <select
              name="hedgePercentage"
              value={formData.hedgePercentage}
              onChange={handleInputChange}
            >
              <option value="25">25%</option>
              <option value="50">50%</option>
              <option value="75">75%</option>
              <option value="100">100%</option>
            </select>
          ) : (
            <input
              type="number"
              name="hedgePercentage"
              value={formData.hedgePercentage}
              onChange={handleInputChange}
              max="100"
              required
            />
          )}
          <button type="button" onClick={toggleInputType}>
            {showDropdown ? 'Type Manually' : 'Select '}
          </button>
        </label>  
        <div className="modal-button-container">
          <button type="submit">Submit</button>
          <button type="button" onClick={closeModal}>Cancel</button>
        </div>
        </form>
      )}
    </Modal>
  );
}

export default ManualHedge;
